import { getBlogs } from "./blogsAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  blogs: [],
  savedblogs: [],
  isLoading: false,
  isError: false,
  error: "",
};

// async thunk
export const fetchBlogs = createAsyncThunk("blogs/fetchBlogs", async () => {
  const blogs = await getBlogs();
  return blogs;
});

const blogsSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {
    defaultBlogs: (state, action) => {
      state.blogs.sort((a, b) => a.id - b.id);
    },
    mostLikedBlogs: (state, action) => {
      state.blogs.sort((a, b) => Number(b.likes) - Number(a.likes));
    },
    newestBlogs: (state, action) => {
      state.blogs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
    addSavedBlog: (state, action) => {
      state.savedblogs.push(action.payload).sort((a, b) => a.id - b.id);
    },
    removeSavedBlog: (state, action) => {
      state.savedblogs = state.savedblogs.filter(
        (blog) => blog.id !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlogs.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchBlogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.blogs = action.payload;
        state.savedblogs = state.blogs.filter((blog) => blog.isSaved === true);
      })
      .addCase(fetchBlogs.rejected, (state, action) => {
        state.isLoading = false;
        state.blogs = [];
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default blogsSlice.reducer;

export const {
  defaultBlogs,
  mostLikedBlogs,
  newestBlogs,
  addSavedBlog,
  removeSavedBlog,
} = blogsSlice.actions;
